import { render, staticRenderFns } from "./SchoolYearPrint.vue?vue&type=template&id=189321e0"
import script from "./SchoolYearPrint.vue?vue&type=script&lang=js"
export * from "./SchoolYearPrint.vue?vue&type=script&lang=js"
import style0 from "./SchoolYearPrint.vue?vue&type=style&index=0&id=189321e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports